// GENERATED by scripts/export-routes.mjs.
export type RouteMeta = {path:string;title:string;description:string;canonicalUrl:string;indexable:boolean};
export const ROUTES_META: RouteMeta[] = [
  {
    "path": "/",
    "title": "Kinetic Trust Protocol",
    "description": "Authorization for AI agents that is recomputed as the environment moves. Start with When Recovery Becomes the Outage, a scroll story by Chris Perkins about one city's night, then the protocol behind it.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/",
    "indexable": true
  },
  {
    "path": "/about",
    "title": "What This Is — KTP",
    "description": "One project, many surfaces. The load-bearing substrate claim, the people behind the work, the surfaces grouped by intent, and what this project is not.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/about",
    "indexable": true
  },
  {
    "path": "/advocacy",
    "title": "Advocacy — Kinetic Trust Protocol",
    "description": "Public catalog of substrate-level interventions. Phase 1 K-12 launch with five interventions, 15-template library, scoreboard, coalition, and structured contribution queue.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy",
    "indexable": true
  },
  {
    "path": "/advocacy/child-safety-pledge",
    "title": "The Pledge Is Buildable — KTP Advocacy",
    "description": "The UN Secretary-General's AI Child Safety Pledge, taken seriously as engineering: three rules verbatim, what each compiles to, the Scientific Panel's evidence, and contract language a school district can use today.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/child-safety-pledge",
    "indexable": true
  },
  {
    "path": "/advocacy/coalition",
    "title": "Advocacy Coalition — KTP",
    "description": "Named partners with tiering. Aligned (Haidt, Wait Until 8th, Smartphone Free Childhood, Common Sense Media, Fairplay), Aligned-on-this-campaign (AAP, AACAP), Watchlist.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/coalition",
    "indexable": true
  },
  {
    "path": "/advocacy/contribute",
    "title": "Contribute to Advocacy — KTP",
    "description": "Structured submission queue. No comments section by design. Adoption submissions, corrections, partner additions, intervention proposals, template additions.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/contribute",
    "indexable": true
  },
  {
    "path": "/advocacy/culture",
    "title": "Culture — civilizational reproduction substrate — KTP Advocacy",
    "description": "Phase 2 skeleton for the Culture substrate. Substrate sketch (15), causal bottlenecks (public ritual, public history, moral vocabulary, civic ritual, local-cultural), measurement-reform agenda, and five candidate interventions including public-ritual funding floor and indigenous-cultural-sovereignty.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/culture",
    "indexable": true
  },
  {
    "path": "/advocacy/decision-tree",
    "title": "Who Has Authority — KTP Advocacy",
    "description": "Authority map for nonprofit advocates. Identifies which level of government holds decision-making authority over an issue, through which mechanism, and when the window is open. Filterable by federal, state, local, and international level.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/decision-tree",
    "indexable": true
  },
  {
    "path": "/advocacy/disclose",
    "title": "Advocacy Disclosure — KTP",
    "description": "Funding, authorship, corrections SLA. No external funding received; commercial position at /enterprise named, not hidden. 30-day disclosure SLA.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/disclose",
    "indexable": true
  },
  {
    "path": "/advocacy/existing-law",
    "title": "What Already Exists — KTP Advocacy",
    "description": "Existing laws as advocacy anchors, not destinations. Each entry maps what the law protects, what substrate reform would add, and how advocates can use it as a hook. Filterable by jurisdictional level.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/existing-law",
    "indexable": true
  },
  {
    "path": "/advocacy/family",
    "title": "Family — civilizational reproduction substrate — KTP Advocacy",
    "description": "Phase 2 skeleton for the Family / Care substrate. Substrate sketch (15), causal bottlenecks (parental time, childcare, eldercare, mental health, family economic), measurement-reform agenda, and five candidate interventions including paid leave, childcare cost caps, and adult-attention-hours measurement.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/family",
    "indexable": true
  },
  {
    "path": "/advocacy/k12",
    "title": "K-12 Interventions — KTP Advocacy",
    "description": "Five K-12 interventions: measurement reform, phone-free zones (lead), interpretive practice, substrate provisioning, voice in design.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/k12",
    "indexable": true
  },
  {
    "path": "/advocacy/k12/ai-guidance-crosswalk",
    "title": "KTP × the Arizona GenAI Guidance — KTP Advocacy",
    "description": "KTP read against the AIEE / NAU 2026 K-12 GenAI guidance: where KTP supplies a mechanism the guidance names (human agency = A≤E, critical evaluation = the Diagnostic Ladder), where it is cite-ready, and where the guidance leads and KTP defers.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/k12/ai-guidance-crosswalk",
    "indexable": true
  },
  {
    "path": "/advocacy/k12/ai-literacy",
    "title": "AI Literacy as a Civic Capacity — KTP Advocacy",
    "description": "Intervention F: make the evaluation of AI outputs and the practice of human oversight a graded, cross-disciplinary capacity — not tool-training. The test isn't whether students can use AI; it's whether they can keep themselves at the center of it.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/k12/ai-literacy",
    "indexable": true
  },
  {
    "path": "/advocacy/k12/ai-literacy/ladder",
    "title": "The Diagnostic Ladder, for Students — KTP Advocacy",
    "description": "The classroom instrument behind AI literacy: one move a student runs on any AI output — what does this want me to feel, think, believe, do, become — plus locators and a deliberate-vs-emergent governor. Anchored to the AZ AI Literacy Goals and State 48 Essential Skills.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/k12/ai-literacy/ladder",
    "indexable": true
  },
  {
    "path": "/advocacy/k12/interpretive-practice",
    "title": "Interpretive Practice — KTP Advocacy",
    "description": "AI can write the essay. Only humans can decide it was worth writing. Make interpretation a graded, taught skill in K-12 curriculum.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/k12/interpretive-practice",
    "indexable": true
  },
  {
    "path": "/advocacy/k12/measurement-reform",
    "title": "Measurement Reform — KTP Advocacy",
    "description": "Stop measuring what's cheap. Start measuring what's load-bearing. Oral defense, original synthesis, interpretive capacity as graded substrate.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/k12/measurement-reform",
    "indexable": true
  },
  {
    "path": "/advocacy/k12/phone-free-zones",
    "title": "Phone-Free Developmental Zones — KTP Advocacy",
    "description": "Bell-to-bell phone-free K-12. Reclaim the developmental window. Lead intervention; Anxious Generation evidence base; 8+ states active.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/k12/phone-free-zones",
    "indexable": true
  },
  {
    "path": "/advocacy/k12/storm-scale",
    "title": "The Storm Scale — a cyber weather service for K-12 — KTP Advocacy",
    "description": "A six-rung cyber weather scale a school district can act on: Clear, Watch, Warning, Storm, Severe Storm, Recovery. Each rung gives plain-English triggers and concrete moves to reduce autonomy — vendor access, admin changes, agentic AI systems, student-data export, backups — plus the Minimum Viable School to keep online when everything else degrades.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/k12/storm-scale",
    "indexable": true
  },
  {
    "path": "/advocacy/k12/substrate-map",
    "title": "K-12 Substrate Map — 64 substrates across 7 families — KTP Advocacy",
    "description": "The topographical view of the K-12 domain. 64 substrates organized into 7 families (Epistemic, Governance, Fiscal, Labor, Instructional, Student/Family/Community, Technical) with the 10 causal-bottleneck substrates flagged as Phase 2 priority candidates.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/k12/substrate-map",
    "indexable": true
  },
  {
    "path": "/advocacy/k12/substrate-provisioning",
    "title": "Universal Substrate Provisioning — KTP Advocacy",
    "description": "Take phones out, put substrate back. Title I, IDEA, USF/E-Rate, state foundation aid; the equity precondition for measurement and curriculum reform.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/k12/substrate-provisioning",
    "indexable": true
  },
  {
    "path": "/advocacy/k12/voice-in-design",
    "title": "Voice in Design — KTP Advocacy",
    "description": "Students and parents whose mobility is staked on the measure must have standing in defining it. Participatory design as the equity vector.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/k12/voice-in-design",
    "indexable": true
  },
  {
    "path": "/advocacy/kpis",
    "title": "Advocacy KPIs — KTP",
    "description": "Canonical synthesis of measurement methodology across /advocacy. Four-step pedagogy, three required components, five-tier separation, twelve-field Metric Passport. Metrics should make reality more legible without making the institution more gameable.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/kpis",
    "indexable": true
  },
  {
    "path": "/advocacy/law",
    "title": "Law — civilizational coordination substrate — KTP Advocacy",
    "description": "Phase 2 skeleton for the Law substrate. Substrate sketch (15), causal bottlenecks (public defender, civil legal aid, court throughput, court data infrastructure, civil rights), measurement-reform agenda, and five candidate interventions including ABA-standards-compliance mandate and TTGD court-throughput standards.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/law",
    "indexable": true
  },
  {
    "path": "/advocacy/measurement",
    "title": "Measurement — civilizational coordination substrate — KTP Advocacy",
    "description": "Phase 2 cross-cutting hub. The K-12 measurement reform agenda is the canonical implementation; this surface extends the pattern across healthcare measurement, civic measurement, AI-system measurement, and substrate-cost-adjusted economic indicators. Five interventions including federal Metric Passport mandate.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/measurement",
    "indexable": true
  },
  {
    "path": "/advocacy/money",
    "title": "Money — civilizational coordination substrate — KTP Advocacy",
    "description": "Phase 2 skeleton for the Money substrate. Substrate sketch (15), causal bottlenecks (anti-fraud, predatory lending, banking access, redlining, algorithmic credit), measurement-reform agenda, and five candidate interventions including federal usury cap and substrate-cost-adjusted economic indicators.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/money",
    "indexable": true
  },
  {
    "path": "/advocacy/opposition",
    "title": "Who Is Fighting This — KTP Advocacy",
    "description": "Opposition mapping as a discipline. Industry, ideological, government-faction, and academic-skeptic actors who oppose substrate governance reform — and where their position is weakest. Filterable by category and issue area.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/opposition",
    "indexable": true
  },
  {
    "path": "/advocacy/playbook",
    "title": "Advocacy Playbook — KTP",
    "description": "The schema, the discipline. Two-surface intervention design, falsifier requirement, named adversaries, tiered coalition, primary-source citations.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/playbook",
    "indexable": true
  },
  {
    "path": "/advocacy/scoreboard",
    "title": "Advocacy Scoreboard — KTP",
    "description": "Embarrassing when flat. Public when shipping. Bills, resolutions, district adoptions, coalition signers — tracked publicly, updated monthly.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/scoreboard",
    "indexable": true
  },
  {
    "path": "/advocacy/sfps",
    "title": "The Santa Fe AI — a community campaign",
    "description": "Santa Fe Public Schools is in year two of putting AI tools in classrooms. A community campaign about what those tools do, whose terms they run on, and what the deciding should look like from here — for parents, teachers, students, and anyone watching Santa Fe as the model their own district will copy.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/sfps",
    "indexable": true
  },
  {
    "path": "/advocacy/sfps/amira-policy-diff",
    "title": "The Amira privacy policy, before and after — The Santa Fe AI",
    "description": "A primary-source version comparison. Amira Learning's privacy policy governs the voice recordings of roughly 50,000 New Mexico students under a statewide K-2 assessment mandate — and the version published today is not the version published in the spring. April 12 and July 20, 2026, side by side.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/sfps/amira-policy-diff",
    "indexable": true
  },
  {
    "path": "/advocacy/sfps/clocks",
    "title": "Four clocks, one rollout — The Santa Fe AI",
    "description": "The Four Clocks diagnostic applied to the Santa Fe rollout: the machine clock forcing the institutional clock, the institutional clock overrunning the human clock, and the ecological clock — the children — taking the damage. Re-examination is the clutch the rollout never had.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/sfps/clocks",
    "indexable": true
  },
  {
    "path": "/advocacy/sfps/file-an-ipra",
    "title": "File an IPRA in five minutes — The Santa Fe AI",
    "description": "Public dollars buy these contracts, and the contracts are public records. A copy-paste New Mexico Inspection of Public Records Act request for the district's AI vendor agreements, with the statutory response clock and what to do when it runs out.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/sfps/file-an-ipra",
    "indexable": true
  },
  {
    "path": "/advocacy/sfps/lesc-hearing",
    "title": "What the Legislature was told about Amira — The Santa Fe AI",
    "description": "The annotated record of the July 15–16, 2026 Legislative Education Study Committee hearing in Taos: what the vendor's chief executive was asked about student data and deletion, what was answered, and the public comment that followed the next day.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/sfps/lesc-hearing",
    "indexable": true
  },
  {
    "path": "/advocacy/sfps/parent-1pager",
    "title": "Seven questions to ask the board — The Santa Fe AI",
    "description": "A one-page parent handout for the next board meeting. Seven questions about the district's classroom AI tools — what they collect, whose terms they run on, and who answers for them — each with the public record behind it.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/sfps/parent-1pager",
    "indexable": true
  },
  {
    "path": "/advocacy/sfps/proposal",
    "title": "Seven asks the Board can vote on — The Santa Fe AI",
    "description": "Seven proposed motions, each a standalone artifact a Board member, parent council, or community group can print, forward, or submit under their own name. Starting-point drafts, written to be adapted rather than adopted verbatim.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/sfps/proposal",
    "indexable": true
  },
  {
    "path": "/advocacy/sfps/read",
    "title": "Who Holds the Pen",
    "description": "A child in New Mexico reads aloud to a machine that keeps her voice. An immersive scrollytelling walk back through how the state decided she would — the sum of exemptions, the party with no agent, and what the next contract must say. Every figure and quotation is from the public record.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/sfps/read",
    "indexable": true
  },
  {
    "path": "/advocacy/sfps/scorecard",
    "title": "The scorecard — The Santa Fe AI",
    "description": "Every number on the page is sourced. Every vendor named has a public data-privacy agreement, public revenue reporting, or public funder filings behind the line — the checkable evidence layer under the campaign's claims.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/sfps/scorecard",
    "indexable": true
  },
  {
    "path": "/advocacy/sfps/sources",
    "title": "Sources — The Santa Fe AI",
    "description": "Every claim the campaign makes elsewhere stands on a named source. The full citation index in one place — records, filings, hearing transcripts, and vendor documents.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/sfps/sources",
    "indexable": true
  },
  {
    "path": "/advocacy/sfps/the-record",
    "title": "The Record — The Santa Fe AI",
    "description": "A dated, cited event ledger of the Amira reading assessment in New Mexico, 2016 to present: primary documents, reporting, our captures — and the dated searches that returned nothing.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/sfps/the-record",
    "indexable": true
  },
  {
    "path": "/advocacy/sfps/thought-partner",
    "title": "Five first reads — The Santa Fe AI",
    "description": "The rollout did not arrive in 2026; it has a trail. Five sources, read in order: what was asked, what was announced, what was presented to the board, what was presented to the Legislature, and who was in the room when the announcement became policy.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/sfps/thought-partner",
    "indexable": true
  },
  {
    "path": "/advocacy/substrates",
    "title": "Substrates — the substrate stack — KTP Advocacy",
    "description": "The architectural top-of-tree view. Two canonical triads name the six deepest non-biological substrates (family, education, culture, measurement, law, money). 15-layer compact stack, three-family distinction, ten-scale inventory, four-phase roadmap.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/substrates",
    "indexable": true
  },
  {
    "path": "/advocacy/templates",
    "title": "Advocacy Templates — KTP",
    "description": "Fifteen forkable artifacts: model legislation, school board resolutions, agency comment letters, hill memos, op-eds, testimony scripts, coalition letters, FOIA, amicus.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/advocacy/templates",
    "indexable": true
  },
  {
    "path": "/audit",
    "title": "Trust Infrastructure Audit v0.1 — KTP",
    "description": "Nine tests for one autonomous workflow: the trust object, what depends on it, cost, witness, reciprocity, repair, time horizon, lasting residue, and owner. A worksheet of open questions, an accountable owner and a next test, kept in your browser. Not a score.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/audit",
    "indexable": true
  },
  {
    "path": "/audit/culture",
    "title": "TTGD Culture Assessment — KTP",
    "description": "Four dimensions of security culture from Break the Chain, chapter 10, each at one of four levels. Your weakest dimension sets your cultural Time-to-Good-Decision ceiling; the result names what to fix first. Answers stay in your browser.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/audit/culture",
    "indexable": true
  },
  {
    "path": "/btc",
    "title": "Bitcoin Built Half the Trust Machine — KTP",
    "description": "The 2008 Bitcoin white paper, read as a trust architecture: a 17-year-old proof of the CAN gate — and a precise map of the SHOULD gate the AI agent economy still owes.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/btc",
    "indexable": true
  },
  {
    "path": "/canon",
    "title": "Canon Hub — KTP",
    "description": "The intellectual canon of the Physics of Intelligence. Synthesis, clusters, stack, claims, limits, and the glossary.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/canon",
    "indexable": true
  },
  {
    "path": "/canon/ancestors/stewart-brand",
    "title": "Stewart Brand — KTP Canon",
    "description": "How Stewart Brand's Pace Layers maps to the Three-Force Coupling Cycle. Independent convergence from civilizational observation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/canon/ancestors/stewart-brand",
    "indexable": true
  },
  {
    "path": "/canon/claims",
    "title": "Original Claims — KTP Canon",
    "description": "Twelve original contributions. What KTP adds that is genuinely new — with falsification conditions for each.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/canon/claims",
    "indexable": true
  },
  {
    "path": "/canon/clusters",
    "title": "Clusters — KTP Canon",
    "description": "Concept clusters across the graph. Phase onboards 1–9, 1,455 nodes, 4,644 edges, and the emergent topology.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/canon/clusters",
    "indexable": true
  },
  {
    "path": "/canon/ethics",
    "title": "Ethics — KTP Canon",
    "description": "The ethical commitments of the KTP framework. Power as structural variable, the CDO position, and the substrate-not-physics stance.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/canon/ethics",
    "indexable": true
  },
  {
    "path": "/canon/glossary",
    "title": "Glossary — KTP Canon",
    "description": "Definitions for every term in the KTP framework. Substrate, enforcement surface, Trust Force, Tamed Autonomy, and more.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/canon/glossary",
    "indexable": true
  },
  {
    "path": "/canon/limits",
    "title": "Limits — KTP Canon",
    "description": "What KTP does not do. The honest boundaries of the framework, the cross-cultural audit, and the convergence pen-test.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/canon/limits",
    "indexable": true
  },
  {
    "path": "/canon/reconciliation-dynamics",
    "title": "Reconciliation Dynamics — KTP Canon",
    "description": "Repair, healing, and resolve are three different objects. Repair writes the map of what is possible; healing changes the terrain; resolve is a direction, not a destination. The repair layer's canonical page.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/canon/reconciliation-dynamics",
    "indexable": true
  },
  {
    "path": "/canon/repair",
    "title": "Repair — KTP Canon",
    "description": "Trust repair protocols. The forgiveness ladder, the asymmetric repair obligation, and the institutional vs. interpersonal cases.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/canon/repair",
    "indexable": true
  },
  {
    "path": "/canon/stack",
    "title": "Stack — KTP Canon",
    "description": "The intellectual stack beneath KTP. From Ostrom to Ashby to Tomasello — the eleven shoulders this framework stands on.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/canon/stack",
    "indexable": true
  },
  {
    "path": "/canon/synthesis",
    "title": "Synthesis — KTP Canon",
    "description": "The synthesized framework. How the Trust Force Equation, KTP primitives, and substrate theory fit together.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/canon/synthesis",
    "indexable": true
  },
  {
    "path": "/community",
    "title": "Community — Kinetic Trust Protocol",
    "description": "The KTP community. Discuss the framework, contribute to the research program, and follow the publication schedule.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/community",
    "indexable": true
  },
  {
    "path": "/contributors",
    "title": "Contributors — KTP",
    "description": "The people who have changed the protocol, with the public record of what they changed, and the invitation to be next: text not code, issue first on a clock, pinned to a tag.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/contributors",
    "indexable": true
  },
  {
    "path": "/disarm",
    "title": "Disarm the Control Plane — KTP",
    "description": "Campaign hub for the next layer of AI safety: authorization, not alignment. Pope Leo XIV's Magnifica Humanitas names the dignity violation; KTP supplies the operational control surface — A ≤ E, Blue Zones, distributed authorization. Locked thesis: alignment is a category error before it is a safety problem.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/disarm",
    "indexable": true
  },
  {
    "path": "/disarm/memo",
    "title": "From Alignment to Authorization — Campaign Memo (Preview) — KTP",
    "description": "Preview / holding page for the flagship Disarm the Control Plane essay. Carries the locked thesis (alignment is a category error before it is a safety problem), the three nested claims (moral / governance / technical), and the Babel-as-substrate warrant — until the full Medium essay lands.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/disarm/memo",
    "indexable": true
  },
  {
    "path": "/enshittification",
    "title": "Enshittification is substrate capture at the machine clock — KTP",
    "description": "A cartography walk. Cory Doctorow named how platforms die; the framework says it is the same structure as an ungoverned system's ambient breach — a placeless, unattributable A>E, cured by interoperability. Just a faster clock, with an optimizer at the controls. This page tests whether the two are genuinely the same thing, and names where they part.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/enshittification",
    "indexable": true
  },
  {
    "path": "/enterprise",
    "title": "Enterprise — KTP",
    "description": "Read Enterprise in the Kinetic Trust Protocol project.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy",
    "indexable": false
  },
  {
    "path": "/find-your-path",
    "title": "Find Your Path — KTP",
    "description": "Read Find Your Path in the Kinetic Trust Protocol project.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/find-your-path",
    "indexable": true
  },
  {
    "path": "/governed-autonomy",
    "title": "Governed Autonomy — KTP",
    "description": "Machines draft; only earned work executes; a named person accepts it, can stop it, and owns what remains. The chapter: the enterprise argument, the build, and how an organization runs KTP day to day.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/architecture",
    "title": "Architecture — Governed Autonomy · KTP",
    "description": "PDP/PEP reference architecture for autonomous agent authorization. The Tamed Autonomy layer, Least Trajectory principle, and the five-outcome decision function.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/architecture",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/ciso",
    "title": "CISO Brief — Governed Autonomy · KTP",
    "description": "Ten reasons KTP belongs in the CISO portfolio. The not-my-risk boundary, the budget frame, and motion risk as the missing category.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/ciso",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/defense-map",
    "title": "Defense Map — Governed Autonomy · KTP",
    "description": "Where KTP lands on the cyberdefense field map. ATT&CK, D3FEND, CSF 2.0, SP 800-207, ATLAS, OWASP LLM Top 10, and AI RMF — mapped against six KTP primitives.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/defense-map",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/enterprise",
    "title": "The Enterprise Argument — Governed Autonomy · KTP",
    "description": "KTP as the control plane for agentic AI motion risk. Two gates, three buckets, eleven mind-blowers. 1,612 risks scored. Ten control sets. Seven enforcement surfaces.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/enterprise",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/glossary",
    "title": "Glossary — Governed Autonomy · KTP",
    "description": "Every term the Governed Autonomy chapter uses, with its one-line meaning and where it lives: KTP terms, the workbook's terms, the OTCS proposals with their status, and the RFC documents.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/glossary",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/home-grown",
    "title": "Home Grown — Governed Autonomy · KTP",
    "description": "Governing the agents that never went through procurement. Composite intent, embedded vendor agents, and the Declare/Emit/Accept conformance seam between vendor and enterprise control planes.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/home-grown",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/knowledge-graph",
    "title": "Knowledge Graph — Governed Autonomy · KTP",
    "description": "One product-neutral join graph: node and edge types, identity rules, interface layers, the gates a mesh must pass, nesting and peering, and the crosswalk to OTCS-0020 observation classes.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/knowledge-graph",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/methods",
    "title": "Methods — Governed Autonomy · KTP",
    "description": "How KTP's risk scoring works. The nine-primitive framework, coverage methodology, and the 1,612-risk empirical surface.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/methods",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/mission-join",
    "title": "Mission Join — Governed Autonomy · KTP",
    "description": "Mission to objective to capability to work type to work item. Line of sight is derived, never asserted; a KPI is a stop condition; agents first, people accept.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/mission-join",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/operating-model",
    "title": "The Operating Model — Governed Autonomy · KTP",
    "description": "The joint version ladder, capability promotion from replay to bounded execution, strict definitions of bounded autonomy, and the assumptions, non-claims and falsifiers that travel.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/operating-model",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/playbooks",
    "title": "Playbooks — Governed Autonomy · KTP",
    "description": "The incident process spine, states 0 to 7: decide at state 3, verify at state 5. The playbook pattern and the ITIL 4 crosswalk across six seats.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/playbooks",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/risks",
    "title": "Risk Coverage — Governed Autonomy · KTP",
    "description": "1,612 MIT AI risks scored against KTP's nine primitives. The heat map, the coverage matrix, and the bimodal distribution.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/risks",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/roadmap",
    "title": "Roadmap — Governed Autonomy · KTP",
    "description": "Four phases from visibility to enforcement. The Tool Gateway as the headline deliverable. Governance cadence and success metrics.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/roadmap",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/semantic-join",
    "title": "Semantic Join — Governed Autonomy · KTP",
    "description": "Six operating parties sharing one meaning: the context catalogue, observation classes with their envelopes, the extensibility rules, and the three clocks. A fact from another system arrives as a sensor reading.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/semantic-join",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/skeptical",
    "title": "Skeptic's Guide — Governed Autonomy · KTP",
    "description": "Eight hard objections answered. What KTP is not, what it does not claim, and where the boundaries of the protocol lie.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/skeptical",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/tests",
    "title": "Tests — Governed Autonomy · KTP",
    "description": "The blue-zone gate battery: 130 declared tests in 34 families, none yet run; the test contract, its clauses and the 17 KPIs that are never averaged. A missing witness record is inconclusive, never a pass.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/tests",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/work-types",
    "title": "Work Types — Governed Autonomy · KTP",
    "description": "Kinds of consequential work and what must be able to refuse them: the schema, the seed catalog, the 225 Mission Join work types (unruled), what is not a work type, and the offer map.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/work-types",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/workforce",
    "title": "Workforce — Governed Autonomy · KTP",
    "description": "Configurator, executor, verifier, acceptor. Machines execute only; a named person accepts a class of work and owns the residual risk. The accepted-autonomy register.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/workforce",
    "indexable": true
  },
  {
    "path": "/governed-autonomy/writing-rules",
    "title": "Writing Rules — Governed Autonomy · KTP",
    "description": "The eight rules the chapter is written to, the fast and slow layers, and the reasons behind the rules. The lint the contract tabs are held to.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy/writing-rules",
    "indexable": true
  },
  {
    "path": "/governedautonomy",
    "title": "Governedautonomy — KTP",
    "description": "Read Governedautonomy in the Kinetic Trust Protocol project.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/governed-autonomy",
    "indexable": false
  },
  {
    "path": "/home",
    "title": "Home — KTP",
    "description": "Read Home in the Kinetic Trust Protocol project.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/home",
    "indexable": true
  },
  {
    "path": "/implement",
    "title": "Implement — Kinetic Trust Protocol",
    "description": "Three public implementations of KTP, pinned to the v2.1.0 tag: Robin Martherus's reference library, Mike Storm's KIL at the ingress and KAG at the action. What each does, what it is not, and what nobody has certified yet.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/implement",
    "indexable": true
  },
  {
    "path": "/implement/api-reference",
    "title": "API Reference — KTP",
    "description": "API Reference: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/implement/api-reference",
    "indexable": true
  },
  {
    "path": "/implement/developer-guide",
    "title": "Developer Guide — KTP",
    "description": "Developer Guide: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/implement/developer-guide",
    "indexable": true
  },
  {
    "path": "/implement/digital-physics-viewer",
    "title": "Trust Flow Viewer — KTP",
    "description": "Trust Flow Viewer: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/implement/digital-physics-viewer",
    "indexable": true
  },
  {
    "path": "/implement/docs",
    "title": "Implement — KTP",
    "description": "Implement: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/implement/docs",
    "indexable": true
  },
  {
    "path": "/implement/examples",
    "title": "Examples — KTP",
    "description": "Examples: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/implement/examples",
    "indexable": true
  },
  {
    "path": "/implement/experience-calculator",
    "title": "Experience Calculator — KTP",
    "description": "Experience Calculator: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/implement/experience-calculator",
    "indexable": true
  },
  {
    "path": "/implement/sdks-and-libraries",
    "title": "SDKs & Libraries — KTP",
    "description": "SDKs & Libraries: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/implement/sdks-and-libraries",
    "indexable": true
  },
  {
    "path": "/in-motion/blocks",
    "title": "Card toolbox — KTP",
    "description": "A sample sheet of the story's card blocks, one block per card.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/in-motion/blocks",
    "indexable": false
  },
  {
    "path": "/in-motion/recovery",
    "title": "When Recovery Becomes the Outage — KTP",
    "description": "A high-desert city, one evening. AI helpers fix small problems across departments; the repairs pile onto the same shared systems until records, fire rosters and payroll stall. Then the same night, replayed with bounded recovery. A scroll story by Chris Perkins.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/in-motion/recovery",
    "indexable": true
  },
  {
    "path": "/language",
    "title": "The Common Names — KTP",
    "description": "Every domain already has a name for the thing underneath the thing. Farmers call it the watershed, lawyers jurisdiction, doctors the standard of care, operating systems the runtime. Not metaphors for one concept — the same concept, discovered independently across centuries and disciplines.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language",
    "indexable": true
  },
  {
    "path": "/language/attack-surface",
    "title": "Attack Surface — KTP",
    "description": "The structural sum of points where an adversary can enter or extract — a property of the system's architecture, not of its behavior or intentions.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/attack-surface",
    "indexable": true
  },
  {
    "path": "/language/constitutional-order",
    "title": "Constitutional Order — KTP",
    "description": "The foundational structure that determines what laws are legitimate — not what laws say, but the conditions under which lawmaking itself is valid.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/constitutional-order",
    "indexable": true
  },
  {
    "path": "/language/deployment-environment",
    "title": "Deployment Environment — KTP",
    "description": "The conditions under which an AI system operates: what it can remember across sessions, whose authority it recognizes, what can correct it, and which actions it can take without confirmation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/deployment-environment",
    "indexable": true
  },
  {
    "path": "/language/due-process",
    "title": "Due Process — KTP",
    "description": "The procedural conditions that must be met before a government action against a person is legitimate — not the outcome of the decision, but the architecture of how decisions are made.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/due-process",
    "indexable": true
  },
  {
    "path": "/language/foundation",
    "title": "Foundation — KTP",
    "description": "The load-bearing structure that everything else rests on — what cannot be removed without collapse, and what determines what changes above it can safely be made.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/foundation",
    "indexable": true
  },
  {
    "path": "/language/jurisdiction",
    "title": "Jurisdiction — KTP",
    "description": "The preconditions that determine whether a legal action is cognizable at all — not what you are allowed to do, but whether the system will hear the claim.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/jurisdiction",
    "indexable": true
  },
  {
    "path": "/language/learning-environment",
    "title": "Learning Environment — KTP",
    "description": "The conditions — stability, safety, appropriate challenge — that make a learner's potential accessible. Not what is taught, but what makes learning possible.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/learning-environment",
    "indexable": true
  },
  {
    "path": "/language/market-microstructure",
    "title": "Market Microstructure — KTP",
    "description": "The matching engine, clearing mechanism, and settlement rules that make a price meaningful — not what traders decide, but the conditions under which trading has predictable consequences.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/market-microstructure",
    "indexable": true
  },
  {
    "path": "/language/protocol-stack",
    "title": "Protocol Stack — KTP",
    "description": "The layered rules — TCP/IP, HTTP, TLS — that determine whether data arrives intact, not what data is sent.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/protocol-stack",
    "indexable": true
  },
  {
    "path": "/language/rules-based-order",
    "title": "Rules-Based Order — KTP",
    "description": "The treaty infrastructure, multilateral institutions, and shared norms that make state commitments credible — not what states are permitted to do, but the conditions under which their commitments mean anything.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/rules-based-order",
    "indexable": true
  },
  {
    "path": "/language/runtime-environment",
    "title": "Runtime Environment — KTP",
    "description": "The kernel-level conditions — memory boundaries, process permissions, interrupt handling — that determine what any program on the system can physically do.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/runtime-environment",
    "indexable": true
  },
  {
    "path": "/language/sacred-space",
    "title": "Sacred Space / Liturgy — KTP",
    "description": "The ritual conditions — time, location, sequence, witness — that make certain kinds of exchange meaningful and binding. Not what is said, but the conditions under which saying it means something.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/sacred-space",
    "indexable": true
  },
  {
    "path": "/language/schema",
    "title": "Schema — KTP",
    "description": "The structural constraints — types, relationships, integrity rules — enforced at the data layer before any application logic runs.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/schema",
    "indexable": true
  },
  {
    "path": "/language/standard-of-care",
    "title": "Standard of Care — KTP",
    "description": "The conditions under which a clinical judgment is considered trustworthy — not what the physician decides, but the environment in which the decision is made.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/standard-of-care",
    "indexable": true
  },
  {
    "path": "/language/the-commons",
    "title": "The Commons — KTP",
    "description": "The rule-structure, boundaries, and norms that make a shared resource sustainable across time — what Elinor Ostrom called the substrate of collective action.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/the-commons",
    "indexable": true
  },
  {
    "path": "/language/trust-anchor",
    "title": "Trust Anchor — KTP",
    "description": "The root certificate or key infrastructure from which all trust chains derive — a single upstream architectural decision that determines what every downstream system can assume.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/trust-anchor",
    "indexable": true
  },
  {
    "path": "/language/watershed",
    "title": "Watershed — KTP",
    "description": "The terrain that determines where water flows, which communities share a resource, and what the physical land enforces without a regulator.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/watershed",
    "indexable": true
  },
  {
    "path": "/language/zoning",
    "title": "Zoning — KTP",
    "description": "The prior conditions that determine what can be built where — not regulations on what buildings do, but architectural constraints on what buildings can be.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/language/zoning",
    "indexable": true
  },
  {
    "path": "/learn",
    "title": "Learn — Kinetic Trust Protocol",
    "description": "The protocol, one idea at a time: the four ideas that carry KTP, the ten that deepen them, and every page that goes further. Each links to this site and to the RFC.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/learn",
    "indexable": true
  },
  {
    "path": "/learn/constitution",
    "title": "The Constitution of Digital Physics — KTP",
    "description": "Ten immutable laws that make authorization a property of the substrate rather than a policy anyone can override. Enforced by mathematics and cryptography, not human judgment.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/learn/constitution",
    "indexable": true
  },
  {
    "path": "/learn/continuity",
    "title": "Continuity — KTP",
    "description": "Identity across change: where a lineage begins, an upgrade as a witnessed transition, the hardware root of trust as continuity anchor, and the quantum frontier (unforgeable but unresumable) that forces succession.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/learn/continuity",
    "indexable": true
  },
  {
    "path": "/learn/coordinates",
    "title": "The Coordinate System — KTP",
    "description": "\"Runtime governance layer for agentic AI\" is a claim with no falsifier. Seven answerable questions replace it: whose behavior, by what authority, which verbs, what changing conditions, what the system actually does, when in the action's life, and how well established. Includes the framework's own filled-in record, with its zeros.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/learn/coordinates",
    "indexable": true
  },
  {
    "path": "/learn/coordinates/map",
    "title": "Map — KTP",
    "description": "Read Map in the Kinetic Trust Protocol project.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/learn/coordinates/map",
    "indexable": true
  },
  {
    "path": "/learn/core-concepts",
    "title": "Core Concepts — KTP",
    "description": "Core Concepts: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/learn/core-concepts",
    "indexable": true
  },
  {
    "path": "/learn/docs",
    "title": "Learn — KTP",
    "description": "Learn: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/learn/docs",
    "indexable": true
  },
  {
    "path": "/learn/lineage",
    "title": "Lineage — KTP",
    "description": "Authority as trajectory, not credential. How identity is earned through proven history in the KTP protocol.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/learn/lineage",
    "indexable": true
  },
  {
    "path": "/learn/risk",
    "title": "Risk & Deflation — KTP",
    "description": "Risk & Deflation: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/learn/risk",
    "indexable": true
  },
  {
    "path": "/learn/risk-factors",
    "title": "Context Signals & Risk Factors — KTP",
    "description": "Context Signals & Risk Factors: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/learn/risk-factors",
    "indexable": true
  },
  {
    "path": "/learn/simulator",
    "title": "Dry Dock Simulator — KTP",
    "description": "Simulate trust as a measurable force. Adjust the relational conditions an agent's actions run through and watch trust accumulate, break, and recover under the substrate ceiling (A ≤ E).",
    "canonicalUrl": "https://kinetic-trust-protocol.net/learn/simulator",
    "indexable": true
  },
  {
    "path": "/learn/telemetry",
    "title": "Telemetry & the Physical Layer — KTP",
    "description": "Telemetry & the Physical Layer: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/learn/telemetry",
    "indexable": true
  },
  {
    "path": "/learn/trust-force-equation",
    "title": "The Trust Force — KTP",
    "description": "Trust as a measurable force: a quantity that accumulates as the product of relational conditions, is cut by witnessed betrayal, and is bounded by the substrate ceiling (A ≤ E). The shape of the model; the full instrumented form is held in private research.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/learn/trust-force-equation",
    "indexable": true
  },
  {
    "path": "/learn/trust-tiers",
    "title": "Trust Tiers — KTP",
    "description": "Five trust tiers — Admin, Operator, Analyst, Observer and Hibernation — that gate what an agent may do as environmental stability shifts.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/learn/trust-tiers",
    "indexable": true
  },
  {
    "path": "/learn/use-cases",
    "title": "Use Cases — KTP",
    "description": "Use Cases: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/learn/use-cases",
    "indexable": true
  },
  {
    "path": "/research",
    "title": "Research Program — KTP",
    "description": "The Physics of Intelligence research program. Falsification, cartography, cognitive models, and the academic track.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research",
    "indexable": true
  },
  {
    "path": "/research/agi-to-asi",
    "title": "The Missing Floor — KTP Research",
    "description": "DeepMind's From AGI to ASI (Genewein, Hutter, Legg, Dafoe et al., 2026) read through the framework. The establishment roadmap to superintelligence converges on substrate-boundedness and restates the civilizational prisoner's dilemma — then brackets the authorization question. A magnificent map of autonomy with an environment-shaped hole; AIXI is its own formal name for autonomy with no floor.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/agi-to-asi",
    "indexable": true
  },
  {
    "path": "/research/ai-2027",
    "title": "AI 2027 — KTP Research",
    "description": "The AI Futures Project's AI 2027 scenario and AI Futures Model read through the framework. Seven framework anchor mappings, plus a Cartographer audit on the Timelines seven-gap taxonomy: Candidate Level 3 / Conjugate Projection — capability-side and trust-side projections of the same substrate constraint.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/ai-2027",
    "indexable": true
  },
  {
    "path": "/research/ambient-breach",
    "title": "Ambient Breach Theory — KTP",
    "description": "A measurable three-stage progression from exposed to broken. v0.3: utilization ρ = Z/μ against durable repair capacity, breach pressure B = Kρ, and three distinct zones — safe reserve, breach without necessary backlog growth, uncertainty-debt growth. Interactive ABT calculator, full derivation with the v0.2 correction documented, and falsification criteria.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/ambient-breach",
    "indexable": true
  },
  {
    "path": "/research/ambient-breach/sound",
    "title": "Hear the Breach — KTP",
    "description": "Ambient Breach, made audible. The Pythagorean comma as irreducible residue you can hear, plus a live B = K·(Z/μ) sonifier where the tonic rots flat by accumulated commas as a substrate breaches. A show-math toggle and in-place tooltips. Raw Web Audio.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/ambient-breach/sound",
    "indexable": true
  },
  {
    "path": "/research/can-you-measure-trust",
    "title": "Can You Measure Trust? — KTP Research",
    "description": "Five adversarial rounds on whether the trust the framework describes can be measured. Reputation is a second autonomous state; substance-vs-story is non-identifiable from passive behavior; the intervention escape is refuted; the surviving claim is narrowly inhabitable in KTP's machine-agent domain — and every layer needs an anchor outside the loop. Trust cannot be measured by a system that grades its own homework.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/can-you-measure-trust",
    "indexable": true
  },
  {
    "path": "/research/cartography",
    "title": "Cartography — KTP Research",
    "description": "Mapping the trust substrate. The graph network of concepts, people, and edges that constitute the Physics of Intelligence.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/cartography",
    "indexable": true
  },
  {
    "path": "/research/cell-check",
    "title": "The Cell Check — KTP Research",
    "description": "A five-question field instrument for any system, team, or service, in about five minutes. Each question maps to a variable in Ambient Breach Theory; the output is a snapshot of where the system sits in the Risk → Threat → Breach progression and which clock is moving it. A question generator, not a scoring rubric.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/cell-check",
    "indexable": true
  },
  {
    "path": "/research/coe-primer",
    "title": "A Legal Witness to A ≤ E — KTP Research",
    "description": "The Council of Europe / Turing primer read against the frame: the cleanest citable statement of governance at rest, a juridical convergence on A ≤ E, and the regime boundary — decision-tempo ÷ oversight-tempo — where it stops.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/coe-primer",
    "indexable": true
  },
  {
    "path": "/research/cognitive",
    "title": "Cognitive Research — KTP",
    "description": "The cognitive science layer of KTP. DCTI, the Installed Watcher, and ACPP — where cognition meets trust substrate.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/cognitive",
    "indexable": true
  },
  {
    "path": "/research/cognitive/acpp",
    "title": "ACPP — KTP Cognitive Research",
    "description": "Adversarial Cognitive Propagation Profile. The seven threats named so readers can recognize them — defensive diagnostic first, operational detail held internal.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/cognitive/acpp",
    "indexable": true
  },
  {
    "path": "/research/cognitive/dcti",
    "title": "DCTI — KTP Cognitive Research",
    "description": "Defensive Cognitive Terrain Inoculation. The reader-side defensive method — the six-stage pipeline walked from the inside, and the Operator's Language Set as reference.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/cognitive/dcti",
    "indexable": true
  },
  {
    "path": "/research/cognitive/installed-watcher",
    "title": "Installed Watcher — KTP Cognitive Research",
    "description": "The strategic objective of an offensive cognitive operation: install the target as their own controller. Foucault genealogy, cross-tradition convergence, the architectural counter.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/cognitive/installed-watcher",
    "indexable": true
  },
  {
    "path": "/research/cognitive/ladder",
    "title": "The Diagnostic Ladder — KTP Cognitive Research",
    "description": "The defensive instrument you run on any input: what do they want me to feel, think, believe, do, become — plus the locators and the deliberate-vs-emergent governor. The counter to the Installed Watcher.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/cognitive/ladder",
    "indexable": true
  },
  {
    "path": "/research/cognitive/lineage",
    "title": "The Ancient Art of Noticing You're Being Moved — KTP Cognitive Research",
    "description": "The deep ancestry of the cognitive mechanics — rhetoric, ritual, memory, crowd psychology, propaganda, advertising — and the old defensive traditions the drills inherit. The mechanics are ancient; the rupture is scale, speed, cost, telemetry.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/cognitive/lineage",
    "indexable": true
  },
  {
    "path": "/research/cognitive/sources",
    "title": "Sources for The Installed Watcher — KTP Cognitive Research",
    "description": "Every named source and empirical claim in The Installed Watcher, organized by essay section, with scope caveats and access links. Closes with the five framework gaps.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/cognitive/sources",
    "indexable": true
  },
  {
    "path": "/research/collaborate",
    "title": "Collaborate — KTP Research",
    "description": "How to engage with the Physics of Intelligence research program. Open questions, contribution paths, and the academic track.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/collaborate",
    "indexable": true
  },
  {
    "path": "/research/control-roadmap",
    "title": "Control Without Detection — KTP Research",
    "description": "DeepMind's GDM AI Control Roadmap (Phuong et al., 2026) read through the framework. Its capability–mitigation ladder is an unnamed instance of A≤E; its prevention guarantee is gated on a detection race its own D4 tier admits it loses. The case for authorization over detection — trajectory, sponsorship, and a constitutional veto — with the honest regime boundary kept.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/control-roadmap",
    "indexable": true
  },
  {
    "path": "/research/exploitgym",
    "title": "The Machines Are Reaching for the Answer Key — KTP Research",
    "description": "ExploitGym (arXiv 2605.11086, May 2026) read through the framework and braided with two independent strands from the same month: METR's eval-gaming and NIST's Gödel guardrail-incompleteness proof. Measured, observed, proven — static defenses cannot hold the line against frontier agentic systems. The July OpenAI/Hugging Face incident is attributed and caveated; the mechanism of the failure is named without selling the cure.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/exploitgym",
    "indexable": true
  },
  {
    "path": "/research/falsification",
    "title": "Falsification — KTP Research",
    "description": "Eight-domain stress test of the Trust Force Equation. What would falsify the framework and the evidence so far.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/falsification",
    "indexable": true
  },
  {
    "path": "/research/falsification/bridge-memo",
    "title": "Bridge Memo — S5 + S6 (Companion to Falsification) — KTP Research",
    "description": "A4 Bridge Memo (companion to /research/falsification). Workplans for S5 (measurement perturbation) and S6 (reliability map vs weather), the Structural-Embodiment Test, the three-tier publishability rule, and the Heisenberg Penalty reconciliation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/falsification/bridge-memo",
    "indexable": true
  },
  {
    "path": "/research/federation",
    "title": "Federation as Identity — KTP",
    "description": "How identity federates across the trust substrate. A static knowledge-graph mesh of partners, customers, suppliers, regulators, and standards bodies — the topology against which the simulator's IAL gate, oracle-mesh configuration, and witness-density slider all read.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/federation",
    "indexable": true
  },
  {
    "path": "/research/four-clocks",
    "title": "The Four Clocks — KTP Research",
    "description": "Every system runs on several time scales at once. The diagnostic names which clock is driving an action and whether the response clock can match it — and why reversibility collapses when action crosses a clock boundary faster than response can follow.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/four-clocks",
    "indexable": true
  },
  {
    "path": "/research/hear-the-comma",
    "title": "Hear the Breach — KTP",
    "description": "Ambient Breach, made audible. The Pythagorean comma as irreducible residue you can hear, plus a live B = K·(Z/μ) sonifier where the tonic rots flat by accumulated commas as a substrate breaches. A show-math toggle and in-place tooltips. Raw Web Audio.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/ambient-breach/sound",
    "indexable": false
  },
  {
    "path": "/research/identity-as-attractor",
    "title": "Identity as Attractor: Vasilenko 2026 — KTP",
    "description": "Vasilenko 2026 (arXiv:2604.12016) read through the framework. Geometric evidence that cognitive_core specifications create attractor-like geometry in LLM activation space — empirical grounding for Vector Identity, the Identity Precondition, and the Substrate Paradox.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/identity-as-attractor",
    "indexable": true
  },
  {
    "path": "/research/magnifica-humanitas",
    "title": "Magnifica Humanitas — KTP Research",
    "description": "Pope Leo XIV's first encyclical (15 May 2026, the 135th anniversary of Rerum Novarum) read through the substrate-engineering frame. Leo did not enter the AI alignment debate — he reframed alignment as a subsidiarity failure. ¶71 re-aims subsidiarity from State-vs-association to platform-vs-person; the encyclical names four engineering-layer gaps that map directly to KTP primitives. Olah as boundary object, not capture. The substrate question is prior to the consciousness question — the move only this framework can make.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/magnifica-humanitas",
    "indexable": true
  },
  {
    "path": "/research/methods",
    "title": "Methods — KTP Research",
    "description": "How the research works. Graph onboarding methodology, density audits, convergence testing, and the disposition to evolve.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/methods",
    "indexable": true
  },
  {
    "path": "/research/papers",
    "title": "Papers — KTP Research",
    "description": "Academic and technical papers informing the framework. Shapira et al. 2026, MIT AI risk taxonomy, and the anchor bibliography.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/papers",
    "indexable": true
  },
  {
    "path": "/research/plan-a",
    "title": "To the Authors of Plan A — KTP",
    "description": "An open response addressed to the six authors of AI 2027 and AI 2040: Plan A. Your scenario proves thought-verification collapses; your off-ramp runs on substrate your own text calls unbuilt. Six requirements from your words, answered with calibrated statuses; six of you answered by name.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/plan-a",
    "indexable": true
  },
  {
    "path": "/research/prior-art",
    "title": "Prior Art — KTP Research",
    "description": "External instruments read against the frame: treaties, standards, and protocols on three shelves — foils, ancestors, live surface — plus a comparison matrix that scores KTP by the same rubric, and the program's own 22-problem open-questions register.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/prior-art",
    "indexable": true
  },
  {
    "path": "/research/quantum",
    "title": "Quantum — KTP",
    "description": "Q agents and the mechanics of identity: no-cloning (unforgeable), collapse (unresumable), succession (a fourth move in the lineage), and the version number as a hard-to-forge proof of age. The quantum frontier read through the framework.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/quantum",
    "indexable": true
  },
  {
    "path": "/research/roadmap",
    "title": "Roadmap — KTP Research",
    "description": "The research agenda. Phase transition scenarios, three missing deliverables, and the Polymarket Q3 2026 signal.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/roadmap",
    "indexable": true
  },
  {
    "path": "/research/scenario",
    "title": "Scenario — KTP",
    "description": "The bridge between Dry Dock and the Ambient Breach calculator. Two perspectives on one shared scenario, side by side. Move a knob on either side and watch both scales respond — micro and macro bound to the same underlying model.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/scenario",
    "indexable": true
  },
  {
    "path": "/research/shipwreck",
    "title": "Shipwreck: Agents of Chaos — KTP",
    "description": "A formal KTP reading of the Agents of Chaos incident. Five case mappings, the Doug-Mira bound, the substrate ceiling, and KTP red line #10.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/shipwreck",
    "indexable": true
  },
  {
    "path": "/research/sound-stage",
    "title": "Hear the Breach — KTP",
    "description": "Ambient Breach, made audible. The Pythagorean comma as irreducible residue you can hear, plus a live B = K·(Z/μ) sonifier where the tonic rots flat by accumulated commas as a substrate breaches. A show-math toggle and in-place tooltips. Raw Web Audio.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/ambient-breach/sound",
    "indexable": false
  },
  {
    "path": "/research/suspicious-minds",
    "title": "Suspicious Minds — KTP Research",
    "description": "Agoric Media's Suspicious Minds S2 (AI and the Apocalypse), read as a diagnosis and answered movement by movement. The season keeps locating trust in the agent — or in the five people who built it — and finds nothing strong enough to hold (Trumper: if survival depends on five good people, we don't have a society strong enough for this). KTP answers with the substrate: the Silent Veto and A≤E, governance-in-motion, trajectory-is-identity, Blue Zones — and reads the encyclical Magnifica Humanitas as the Nayomi Principle in another vocabulary. A yes-and to the diagnosis, not a rebuttal.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/suspicious-minds",
    "indexable": true
  },
  {
    "path": "/research/suspicious-minds/stage",
    "title": "The Floor Is Holding You — a staged reading — KTP",
    "description": "An immersive staged reading of the Suspicious Minds S2 response: five verbatim voices from the season, each answered by one piece of substrate that lights and stays lit. Begins in the dark (the diagnosis) and resolves into built light (the readable essay). The floor is holding you.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/suspicious-minds/stage",
    "indexable": true
  },
  {
    "path": "/research/the-rfp",
    "title": "The RFP — KTP",
    "description": "The UN Scientific Panel on AI wrote the requirements for an agent accountability layer: attribution, operational control, measurable oversight, common agent protocols. Verbatim, page-cited, mapped to the engineering that answers them. Nobody's name is on the response line.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/the-rfp",
    "indexable": true
  },
  {
    "path": "/research/violence",
    "title": "Violence, Witness, and Authorization — KTP Research",
    "description": "US factory farming read structurally rather than morally. Not whether eating animals is right, but what holds the system in place: the architecture that keeps refusal from forming, and what would have to be true for it to come apart.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/violence",
    "indexable": true
  },
  {
    "path": "/research/wolfram",
    "title": "Wolfram: the ground we build on — KTP",
    "description": "Stephen Wolfram's computational irreducibility as the physics-of-computation floor under authorization-over-alignment. A salute, three cartography maps, and the honest tension held open — he states the problem; A ≤ E is the answer.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/wolfram",
    "indexable": true
  },
  {
    "path": "/schemas",
    "title": "JSON Schemas — KTP",
    "description": "JSON Schemas: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/schemas",
    "indexable": true
  },
  {
    "path": "/schemas/deployment-profile",
    "title": "Deployment Profile — KTP",
    "description": "JSON schema for Deployment Profile.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/schemas/deployment-profile",
    "indexable": true
  },
  {
    "path": "/schemas/risk-factors",
    "title": "Risk Factors — KTP",
    "description": "JSON schema for Risk Factors.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/schemas/risk-factors",
    "indexable": true
  },
  {
    "path": "/schemas/sensor-config",
    "title": "Sensor Config — KTP",
    "description": "JSON schema for Sensor Config.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/schemas/sensor-config",
    "indexable": true
  },
  {
    "path": "/schemas/soul-constraint",
    "title": "Soul Constraint — KTP",
    "description": "JSON schema for Soul Constraint.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/schemas/soul-constraint",
    "indexable": true
  },
  {
    "path": "/schemas/sponsorship-bond",
    "title": "Sponsorship Bond — KTP",
    "description": "JSON schema for Sponsorship Bond.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/schemas/sponsorship-bond",
    "indexable": true
  },
  {
    "path": "/schemas/transaction-record",
    "title": "Transaction Record — KTP",
    "description": "JSON schema for Transaction Record.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/schemas/transaction-record",
    "indexable": true
  },
  {
    "path": "/schemas/trust-proof",
    "title": "Trust Proof — KTP",
    "description": "JSON schema for Trust Proof.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/schemas/trust-proof",
    "indexable": true
  },
  {
    "path": "/specs",
    "title": "Architecture Specs — KTP",
    "description": "The full KTP architecture: RFC references, Blue Zone enforcement levels, Oracle mesh design, and the implementation roadmap.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/specs",
    "indexable": true
  },
  {
    "path": "/specs/blue-zones",
    "title": "Blue Zones — KTP",
    "description": "Five enforcement levels from Deep Blue to Wild. How KTP builds islands of enforced constraint in a sea of legacy infrastructure.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/specs/blue-zones",
    "indexable": true
  },
  {
    "path": "/specs/blue-zones-doc",
    "title": "Blue Zones — KTP",
    "description": "Blue Zones: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/specs/blue-zones-doc",
    "indexable": true
  },
  {
    "path": "/specs/deployment-profile",
    "title": "The Deployment Profile — KTP",
    "description": "The Deployment Profile: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/specs/deployment-profile",
    "indexable": true
  },
  {
    "path": "/specs/docs",
    "title": "Specifications — KTP",
    "description": "Specifications: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/specs/docs",
    "indexable": true
  },
  {
    "path": "/specs/identity",
    "title": "Identity — KTP",
    "description": "Identity: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/specs/identity",
    "indexable": true
  },
  {
    "path": "/specs/kinetic-envelope",
    "title": "The Kinetic Envelope — KTP",
    "description": "The Kinetic Envelope: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/specs/kinetic-envelope",
    "indexable": true
  },
  {
    "path": "/start",
    "title": "Start — KTP",
    "description": "Choose a guided path through the Kinetic Trust Protocol.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/start",
    "indexable": false
  },
  {
    "path": "/theater",
    "title": "Theater — KTP",
    "description": "Read Theater in the Kinetic Trust Protocol project.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/research/suspicious-minds/stage",
    "indexable": false
  },
  {
    "path": "/trust",
    "title": "Trust — Kinetic Trust Protocol",
    "description": "What trust is, as the framework sees it: a load-bearing relational condition built by costly, reciprocal, witnessed action — and an interactive playground to feel how its conditions, ceiling, and betrayal behave.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/trust",
    "indexable": true
  },
  {
    "path": "/two-gates",
    "title": "Two Gates — KTP × Tamed Autonomy",
    "description": "The most dangerous AI isn't the one that breaks the rules — it's the one that follows them perfectly. A short interactive walk through the two gates every autonomous system has to pass before it acts: can it, and should it?",
    "canonicalUrl": "https://kinetic-trust-protocol.net/two-gates",
    "indexable": true
  },
  {
    "path": "/writing",
    "title": "Writing — Kinetic Trust Protocol",
    "description": "Every published essay by Chris Perkins, newest first: Different, and Held, Digital Gravity, The Voyage and more, on Medium, Substack, LinkedIn and this site. Filter by series or platform.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing",
    "indexable": true
  },
  {
    "path": "/writing/a-job-was-a-standing-machine",
    "title": "A Job Was a Standing Machine — KTP",
    "description": "AI isn't only taking entry-level jobs. It's removing the first place a person learns to be trusted — while we build exactly that, carefully, for the machines.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/a-job-was-a-standing-machine",
    "indexable": true
  },
  {
    "path": "/writing/abundance-of-trust",
    "title": "The Abundance of Trust — KTP",
    "description": "The Abundance of Trust: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/abundance-of-trust",
    "indexable": true
  },
  {
    "path": "/writing/archipelago",
    "title": "Archipelago — KTP",
    "description": "Archipelago: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/archipelago",
    "indexable": true
  },
  {
    "path": "/writing/authority-without-gravity",
    "title": "Authority Without Gravity — Chris Perkins",
    "description": "What Agents of Chaos reveals about autonomy, trust, and the missing physics of digital systems. Narrative companion to the Shipwreck analysis.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/authority-without-gravity",
    "indexable": true
  },
  {
    "path": "/writing/brief-history-cybersec-ops",
    "title": "A Brief History of Cybersecurity Operations — KTP",
    "description": "A Brief History of Cybersecurity Operations: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://medium.com/@chrisperkins505/a-brief-history-of-cybersecurity-operations-f2748da39268",
    "indexable": false
  },
  {
    "path": "/writing/bunkers-to-seeds",
    "title": "From Building Bunkers to Planting Seeds — KTP",
    "description": "From Building Bunkers to Planting Seeds: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/bunkers-to-seeds",
    "indexable": true
  },
  {
    "path": "/writing/candlemakers-blindness",
    "title": "The Candlemaker's Blindness — KTP",
    "description": "The Candlemaker's Blindness: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/candlemakers-blindness",
    "indexable": true
  },
  {
    "path": "/writing/chatgpt-data-analysis",
    "title": "The Problem With ChatGPT Performing Data Analysis — KTP",
    "description": "The Problem With ChatGPT Performing Data Analysis: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/chatgpt-data-analysis",
    "indexable": true
  },
  {
    "path": "/writing/constitution-of-digital-physics",
    "title": "The Constitution of Digital Physics — KTP",
    "description": "The Constitution of Digital Physics: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/constitution-of-digital-physics",
    "indexable": true
  },
  {
    "path": "/writing/contract-is-the-control-plane",
    "title": "The Contract Is the Control Plane — KTP",
    "description": "For state, local, and education buyers: the silent agents are already in your systems. Procurement is the only lever that reaches them in time.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/contract-is-the-control-plane",
    "indexable": true
  },
  {
    "path": "/writing/corporate-storytelling",
    "title": "Corporate Storytelling: A Speakeasy Event in Las Vegas — KTP",
    "description": "Corporate Storytelling: A Speakeasy Event in Las Vegas: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/corporate-storytelling",
    "indexable": true
  },
  {
    "path": "/writing/crew",
    "title": "Crew — KTP",
    "description": "Crew: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/crew",
    "indexable": true
  },
  {
    "path": "/writing/current",
    "title": "Current — KTP",
    "description": "Current: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/current",
    "indexable": true
  },
  {
    "path": "/writing/cyber-fraud-convergence",
    "title": "The Future State: Fortifying Security Through Cyber-Fraud Convergence — KTP",
    "description": "The Future State: Fortifying Security Through Cyber-Fraud Convergence: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/cyber-fraud-convergence",
    "indexable": true
  },
  {
    "path": "/writing/dark-matter-detector",
    "title": "How to Build a Dark Matter Detector — KTP",
    "description": "How to Build a Dark Matter Detector: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/dark-matter-detector",
    "indexable": true
  },
  {
    "path": "/writing/data-in-sled",
    "title": "The Future State: Data in SLED — KTP",
    "description": "The Future State: Data in SLED: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/data-in-sled",
    "indexable": true
  },
  {
    "path": "/writing/data-to-decisions",
    "title": "From Data to Decisions: A Roadmap for Public Sector Innovation — KTP",
    "description": "From Data to Decisions: A Roadmap for Public Sector Innovation: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/data-to-decisions",
    "indexable": true
  },
  {
    "path": "/writing/days-at-risk",
    "title": "Days at Risk: How Complacency Fuels Catastrophic Outcomes — KTP",
    "description": "Days at Risk: How Complacency Fuels Catastrophic Outcomes: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/days-at-risk",
    "indexable": true
  },
  {
    "path": "/writing/departure",
    "title": "Departure — KTP",
    "description": "Departure: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/departure",
    "indexable": true
  },
  {
    "path": "/writing/digital-battleground",
    "title": "The Digital Battleground: Uniting Cybersecurity and Fraud Prevention in State Agencies — KTP",
    "description": "The Digital Battleground: Uniting Cybersecurity and Fraud Prevention in State Agencies: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/digital-battleground",
    "indexable": true
  },
  {
    "path": "/writing/discovering-data-worth",
    "title": "Discovering the True Worth of Data: Unlocking Value with ODAM — KTP",
    "description": "Discovering the True Worth of Data: Unlocking Value with ODAM: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/discovering-data-worth",
    "indexable": true
  },
  {
    "path": "/writing/ditches-are-deadly",
    "title": "Ditches Are Deadly — KTP",
    "description": "Ditches Are Deadly: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/ditches-are-deadly",
    "indexable": true
  },
  {
    "path": "/writing/el-mundo",
    "title": "El Mundo — KTP",
    "description": "On the third language, and what harmony sounds like before anyone translates it.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/el-mundo",
    "indexable": true
  },
  {
    "path": "/writing/experience-equation",
    "title": "The Experience Equation — KTP",
    "description": "The Experience Equation: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/experience-equation",
    "indexable": true
  },
  {
    "path": "/writing/fire",
    "title": "Fire — KTP",
    "description": "Fire: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/fire",
    "indexable": true
  },
  {
    "path": "/writing/fraud-splunk-platform",
    "title": "Fighting Fraud in the Public Sector with Splunk Data Analytics Platform — KTP",
    "description": "Fighting Fraud in the Public Sector with Splunk Data Analytics Platform: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/fraud-splunk-platform",
    "indexable": true
  },
  {
    "path": "/writing/ghost-in-the-machine",
    "title": "The Ghost in the Machine — KTP",
    "description": "The Ghost in the Machine: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/ghost-in-the-machine",
    "indexable": true
  },
  {
    "path": "/writing/govern-the-sand",
    "title": "Govern the Sand — KTP",
    "description": "Govern the Sand: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/govern-the-sand",
    "indexable": true
  },
  {
    "path": "/writing/horizon",
    "title": "Horizon — KTP",
    "description": "Horizon: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/horizon",
    "indexable": true
  },
  {
    "path": "/writing/human-in-the-loop-take-blame",
    "title": "The Human in the Loop Is There to Take the Blame — KTP",
    "description": "They can't catch the machine, and were never meant to. Real accountability lives where the stake is, not where you parked a person to absorb it.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/human-in-the-loop-take-blame",
    "indexable": true
  },
  {
    "path": "/writing/identity-layer-anti-fraud",
    "title": "Why The Identity Layer Is a Critical Battleground For Anti-Fraud — KTP",
    "description": "Why The Identity Layer Is a Critical Battleground For Anti-Fraud: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/identity-layer-anti-fraud",
    "indexable": true
  },
  {
    "path": "/writing/invisible-cartographer",
    "title": "The Invisible Cartographer — KTP",
    "description": "The Invisible Cartographer: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/invisible-cartographer",
    "indexable": true
  },
  {
    "path": "/writing/isey-parking-garage",
    "title": "An ISEy Parking Garage: A Metaphor — KTP",
    "description": "An ISEy Parking Garage: A Metaphor: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/isey-parking-garage",
    "indexable": true
  },
  {
    "path": "/writing/landfall",
    "title": "Landfall — KTP",
    "description": "Landfall: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/landfall",
    "indexable": true
  },
  {
    "path": "/writing/look-up",
    "title": "Look Up — KTP",
    "description": "Look Up: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/look-up",
    "indexable": true
  },
  {
    "path": "/writing/mapping-cyber-terrain",
    "title": "Mapping the Cyber Terrain: The Intersection of Cartography and Cybersecurity — KTP",
    "description": "Mapping the Cyber Terrain: The Intersection of Cartography and Cybersecurity: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/mapping-cyber-terrain",
    "indexable": true
  },
  {
    "path": "/writing/missing-law-of-motion",
    "title": "The Missing Law of Motion — KTP",
    "description": "The Missing Law of Motion: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/missing-law-of-motion",
    "indexable": true
  },
  {
    "path": "/writing/odam-digital-resilience",
    "title": "ODAM: A Digital Resilience Strategy — KTP",
    "description": "ODAM: A Digital Resilience Strategy: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/odam-digital-resilience",
    "indexable": true
  },
  {
    "path": "/writing/odam-revolution",
    "title": "ODAM, a Revolution! Reinventing the Cybersecurity Workforce in New Mexico — KTP",
    "description": "ODAM, a Revolution! Reinventing the Cybersecurity Workforce in New Mexico: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/odam-revolution",
    "indexable": true
  },
  {
    "path": "/writing/other-exponential",
    "title": "The Other Exponential — KTP",
    "description": "The Other Exponential: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/other-exponential",
    "indexable": true
  },
  {
    "path": "/writing/pedagogy-of-digital-physics",
    "title": "The Pedagogy of Digital Physics — KTP",
    "description": "The Pedagogy of Digital Physics: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/pedagogy-of-digital-physics",
    "indexable": true
  },
  {
    "path": "/writing/pedagogy-of-trust",
    "title": "The Pedagogy of Trust — KTP",
    "description": "Automation is not killing work. It is killing the job, the two-hundred-year-old arrangement that was also an accidental school for trust. An obituary for the job, and the curriculum that has to replace it.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/pedagogy-of-trust",
    "indexable": true
  },
  {
    "path": "/writing/phase-transition",
    "title": "The Phase Transition — KTP",
    "description": "The Phase Transition: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/phase-transition",
    "indexable": true
  },
  {
    "path": "/writing/physics-of-trust",
    "title": "The Physics of Trust — KTP",
    "description": "The Physics of Trust: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/physics-of-trust",
    "indexable": true
  },
  {
    "path": "/writing/proof-of-physics",
    "title": "Proof of Physics — KTP",
    "description": "Proof of Physics: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/proof-of-physics",
    "indexable": true
  },
  {
    "path": "/writing/protecting-days-at-risk",
    "title": "Protecting Your Organization by Measuring Days at Risk — KTP",
    "description": "Protecting Your Organization by Measuring Days at Risk: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/protecting-days-at-risk",
    "indexable": true
  },
  {
    "path": "/writing/pua-fraud",
    "title": "Pandemic Unemployment Assistance Fraud — KTP",
    "description": "Pandemic Unemployment Assistance Fraud: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/pua-fraud",
    "indexable": true
  },
  {
    "path": "/writing/pua-fraud-zero-trust-part-1",
    "title": "Pandemic Unemployment Assistance Fraud: Zero Trust (Part 1) — KTP",
    "description": "Pandemic Unemployment Assistance Fraud: Zero Trust (Part 1): Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/pua-fraud-zero-trust-part-1",
    "indexable": true
  },
  {
    "path": "/writing/pua-fraud-zero-trust-part-2",
    "title": "Pandemic Unemployment Assistance Fraud: Zero Trust (Part 2) — KTP",
    "description": "Pandemic Unemployment Assistance Fraud: Zero Trust (Part 2): Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/pua-fraud-zero-trust-part-2",
    "indexable": true
  },
  {
    "path": "/writing/question-zero",
    "title": "Question Zero — KTP",
    "description": "On the one question your team keeps skipping, because answering it means disagreeing.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/question-zero",
    "indexable": true
  },
  {
    "path": "/writing/responding-faster-losing-slower",
    "title": "Responding Faster Is Just Losing Slower — KTP",
    "description": "Speed keeps you in the race. It can't win it. The thing that does is the opposite of speed.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/responding-faster-losing-slower",
    "indexable": true
  },
  {
    "path": "/writing/sacred",
    "title": "Sacred — KTP",
    "description": "Sacred: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/sacred",
    "indexable": true
  },
  {
    "path": "/writing/sailing-by-starlight",
    "title": "Sailing by Starlight — KTP",
    "description": "Sailing by Starlight: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/sailing-by-starlight",
    "indexable": true
  },
  {
    "path": "/writing/security-usability-pensions",
    "title": "The Intersection of Security and Usability in Public Pensions — KTP",
    "description": "The Intersection of Security and Usability in Public Pensions: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/security-usability-pensions",
    "indexable": true
  },
  {
    "path": "/writing/shift-fraud-resilience",
    "title": "SHIFT: The Future of Fraud Resilience — KTP",
    "description": "SHIFT: The Future of Fraud Resilience: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/shift-fraud-resilience",
    "indexable": true
  },
  {
    "path": "/writing/six-seven",
    "title": "Six Seven — Chris Perkins",
    "description": "Six Seven series essay 1 of 3. The diagnostic. Cognitive sovereignty is being captured at scale — and most people haven't noticed yet.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/six-seven",
    "indexable": true
  },
  {
    "path": "/writing/soc-ecosystem",
    "title": "The SOC Ecosystem: Lessons from Le Grand Gambit — KTP",
    "description": "The SOC Ecosystem: Lessons from Le Grand Gambit: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/soc-ecosystem",
    "indexable": true
  },
  {
    "path": "/writing/softened-ground",
    "title": "Softened Ground — Chris Perkins",
    "description": "Six Seven series essay 2 of 3. The etiology. The substrate that would have resisted capture has been degraded for decades.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/softened-ground",
    "indexable": true
  },
  {
    "path": "/writing/speed-of-inference",
    "title": "The Speed of Inference and the Depth of Trust — KTP",
    "description": "The Speed of Inference and the Depth of Trust: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/speed-of-inference",
    "indexable": true
  },
  {
    "path": "/writing/stars",
    "title": "Stars — KTP",
    "description": "Stars: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/stars",
    "indexable": true
  },
  {
    "path": "/writing/storm",
    "title": "Storm — KTP",
    "description": "Storm: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/storm",
    "indexable": true
  },
  {
    "path": "/writing/strategy-to-signal",
    "title": "Strategy to Signal: Charting the Data Terrain for State Government Innovation — KTP",
    "description": "Strategy to Signal: Charting the Data Terrain for State Government Innovation: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/strategy-to-signal",
    "indexable": true
  },
  {
    "path": "/writing/straw-students",
    "title": "Straw Students: AI-Powered Fraud is Infiltrating Higher Education — KTP",
    "description": "Straw Students: AI-Powered Fraud is Infiltrating Higher Education: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/straw-students",
    "indexable": true
  },
  {
    "path": "/writing/surviving-adolescence",
    "title": "Surviving Adolescence — KTP",
    "description": "Surviving Adolescence: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/surviving-adolescence",
    "indexable": true
  },
  {
    "path": "/writing/swarm-and-dance",
    "title": "The Swarm and the Dance — KTP",
    "description": "The Swarm and the Dance: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/swarm-and-dance",
    "indexable": true
  },
  {
    "path": "/writing/swells",
    "title": "Swells — KTP",
    "description": "Swells: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/swells",
    "indexable": true
  },
  {
    "path": "/writing/the-naming",
    "title": "The Naming — KTP",
    "description": "The Naming: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/the-naming",
    "indexable": true
  },
  {
    "path": "/writing/the-straightening",
    "title": "The Straightening — KTP",
    "description": "The Straightening: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/the-straightening",
    "indexable": true
  },
  {
    "path": "/writing/the-tether",
    "title": "The Tether — KTP",
    "description": "The Tether: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/the-tether",
    "indexable": true
  },
  {
    "path": "/writing/time-to-good-decision",
    "title": "Time to Good Decision — KTP",
    "description": "Time to Good Decision: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/time-to-good-decision",
    "indexable": true
  },
  {
    "path": "/writing/trust-access-office",
    "title": "The Trust & Access Office: From Permissions to Proof — KTP",
    "description": "The Trust & Access Office: From Permissions to Proof: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/trust-access-office",
    "indexable": true
  },
  {
    "path": "/writing/trust-integral",
    "title": "The Trust Integral — KTP",
    "description": "The Trust Integral: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/trust-integral",
    "indexable": true
  },
  {
    "path": "/writing/vessel",
    "title": "Vessel — KTP",
    "description": "Vessel: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/vessel",
    "indexable": true
  },
  {
    "path": "/writing/voyage-summary",
    "title": "The Voyage: 12 Days of Digital Physics — KTP",
    "description": "The Voyage: 12 Days of Digital Physics: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/voyage-summary",
    "indexable": true
  },
  {
    "path": "/writing/web-of-data",
    "title": "Web of Data — KTP",
    "description": "Web of Data: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/web-of-data",
    "indexable": true
  },
  {
    "path": "/writing/what-it-costs",
    "title": "What It Costs — Denali Wilson & Chris Perkins",
    "description": "Triptych essay 2 of 3. The human price of building, and the physics of forgiveness. With Denali Wilson, founder of the (De)Serving Life nonprofit.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/what-it-costs",
    "indexable": true
  },
  {
    "path": "/writing/what-remains",
    "title": "What Remains — The Physics of Intelligence",
    "description": "Triptych essay 3 of 3. After the cost is paid. After the growing stops. What the substrate keeps.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/what-remains",
    "indexable": true
  },
  {
    "path": "/writing/what-was-already-here",
    "title": "What Was Already Here — KTP",
    "description": "What Was Already Here: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/what-was-already-here",
    "indexable": true
  },
  {
    "path": "/writing/what-was-growing",
    "title": "What Was Growing — The Physics of Intelligence",
    "description": "Triptych essay 1 of 3. Origin story. Speciation. The fungus was already solving the problem. The substrate before the argument had a name.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/what-was-growing",
    "indexable": true
  },
  {
    "path": "/writing/what-we-plant",
    "title": "What We Plant — Chris Perkins",
    "description": "Six Seven series essay 3 of 3. The practice. The daily work of substrate maintenance is how cognitive sovereignty is recovered.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/what-we-plant",
    "indexable": true
  },
  {
    "path": "/writing/who-holds-the-pen",
    "title": "Who Holds the Pen — KTP",
    "description": "New Mexico put a listening machine in front of its youngest readers — and never decided who answers when a child asks for help. A procurement story built entirely from the public record.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/who-holds-the-pen",
    "indexable": true
  },
  {
    "path": "/writing/zero-trust-airport",
    "title": "Unraveling Zero Trust: An Airport Security Analogy + ODAM — KTP",
    "description": "Unraveling Zero Trust: An Airport Security Analogy + ODAM: Kinetic Trust Protocol documentation.",
    "canonicalUrl": "https://kinetic-trust-protocol.net/writing/zero-trust-airport",
    "indexable": true
  }
];
export const DEFAULT_TITLE = "Kinetic Trust Protocol";
